import React from 'react';
import { Chip, ChipProps } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

interface StyledProps {
    labelFontSize?: number | string;
    labelFontWeight?: React.CSSProperties['fontWeight'];
    labelColor?: React.CSSProperties['color'];
}

interface StyledChipProps extends StyledProps, ChipProps {}

const useStyles = makeStyles<Theme, StyledProps>((theme) => ({
    chip: ({ labelFontSize, labelFontWeight, labelColor }) => ({
        '& .MuiChip-label': {
            fontSize: labelFontSize ?? theme.typography.fontSize,
            fontWeight: labelFontWeight ?? theme.typography.fontWeightRegular,
            ...(labelColor ? { color: labelColor } : {}),
        },
    }),
}));

const StyledChip: React.FC<StyledChipProps> = ({ labelFontSize, labelFontWeight, labelColor, ...props }) => {
    const classes = useStyles({ labelFontSize, labelFontWeight, labelColor });
    return <Chip className={classes.chip} {...props} />;
};

export default StyledChip;
